import { React } from '@/vendor'

export default (props) => (
	<svg width={26} height={26} viewBox="0 0 26 26" {...props}>
		<path d="M22.89.404l2.1 2.101-10.15 10.149 10.524 10.523-2.1 2.102L12.74 14.755 2.363 25.133.262 23.03l10.377-10.377L.636 2.651 2.736.55 12.74 10.553 22.89.404z" />
	</svg>
)
